module.exports = __webpack_public_path__ + "static/media/jasmineCarbone.7e5d0b53.jpg";